/**
 * @generated SignedSource<<00032fd694469773438659d9caa25c58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type generalAssetMeasurementReportPagemeasurementTemplatesQuery$variables = {};
export type generalAssetMeasurementReportPagemeasurementTemplatesQueryVariables = generalAssetMeasurementReportPagemeasurementTemplatesQuery$variables;
export type generalAssetMeasurementReportPagemeasurementTemplatesQuery$data = {
  readonly measurementTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type generalAssetMeasurementReportPagemeasurementTemplatesQueryResponse = generalAssetMeasurementReportPagemeasurementTemplatesQuery$data;
export type generalAssetMeasurementReportPagemeasurementTemplatesQuery = {
  variables: generalAssetMeasurementReportPagemeasurementTemplatesQueryVariables;
  response: generalAssetMeasurementReportPagemeasurementTemplatesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "assetType",
        "value": "general_asset"
      }
    ],
    "concreteType": "MeasurementTemplateConnection",
    "kind": "LinkedField",
    "name": "measurementTemplates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeasurementTemplateEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "measurementTemplates(assetType:\"general_asset\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "generalAssetMeasurementReportPagemeasurementTemplatesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "generalAssetMeasurementReportPagemeasurementTemplatesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "99eef9ef863c7eb0e1d6d40341660628",
    "id": null,
    "metadata": {},
    "name": "generalAssetMeasurementReportPagemeasurementTemplatesQuery",
    "operationKind": "query",
    "text": "query generalAssetMeasurementReportPagemeasurementTemplatesQuery {\n  measurementTemplates(assetType: general_asset) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f13104733ab3f1f91ea0f46dcd0f597e";

export default node;
